import { MenuRoute } from '../../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the News module (moduleId=6).
 */
export const NEWS_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/home/news',
    labelKey: 'NewsList.title',
    icon: '/assets/tablerIcons/outline/news.svg',
    moduleId: 6,
    groupLabelKey: 'MenuRoutes.group.newsViews'
  },
  {
    path: '/settings/manage-news',
    labelKey: 'News.manageNews',
    icon: '/assets/tablerIcons/outline/settings.svg',
    moduleId: 6,
    groupLabelKey: 'MenuRoutes.group.newsAdmin',
    requiresAdmin: true
  }
];
